import Index from './Index';
import SettingsContent from '../Wrapper';
import IntegrationHooks from './IntegrationHooks';
import Webhook from '../integrations/Webhooks/Index';
import DashboardApps from '../integrations/DashboardApps/Index';
import WebhooksSendMessage from '../integrations/WebhooksSendMessage/Index';
import webhooksSendMessageLogs from '../integrations/webhooksSendMessageLogs/Index';
import Assistent from '../integrations/Assistents/Index';
import Syonet from '../integrations/syonet/Index';
import { frontendURL } from '../../../../helper/URLHelper';

const SUB_ROUTE_NAMES = [
  'settings_applications_integration',
  'settings_applications_webhook',
  'settings_applications_dashboard_apps',
  'settings_applications_cadence',
  'settings_applications_assistent',
  'settings_applications_syonet',
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/applications'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_applications';
        const backUrl = SUB_ROUTE_NAMES.includes(params.name)
          ? { name: 'settings_applications' }
          : '';
        return {
          headerTitle: 'INTEGRATION_APPS.HEADER',
          icon: 'star-emphasis',
          showBackButton,
          backUrl,
        };
      },
      children: [
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          roles: ['administrator', 'supervisor'],
          accountTypes: ['account', 'subaccount', 'parent_account'],
        },
        {
          path: 'webhook',
          name: 'settings_applications_webhook',
          component: Webhook,
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'dashboard-apps',
          name: 'settings_applications_dashboard_apps',
          component: DashboardApps,
          roles: ['administrator', 'supervisor'],
          accountTypes: ['account', 'subaccount', 'parent_account'],
        },        
        {
          path: 'webhooks-send-messages/logs',
          component: webhooksSendMessageLogs,
          name: 'settings_integrations_webhooks_send_message_logs',
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'webhooks-send-messages/:partner',
          component: WebhooksSendMessage,
          name: 'settings_integrations_webhooks_send_message',
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'webhooks-send-messages',
          component: webhooksSendMessageLogs,
          name: 'settings_integrations_webhooks_send_message_logs',
          roles: ['administrator', 'supervisor'],
          redirect: () => {
            return frontendURL('accounts/:accountId/settings/applications');
          }
        },
        {
          path: 'assistent',
          name: 'settings_applications_assistent',
          component: Assistent,
          roles: ['administrator', 'supervisor'],
        },
        {
          path: 'syonet',
          name: 'settings_applications_syonet',
          component: Syonet,
          roles: ['administrator', 'supervisor'],
        },
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          roles: ['administrator', 'supervisor'],
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
  ],
};